import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Alert, Row } from 'reactstrap'
import AutoTable from 'components/AutoTable'

class SkuGrid extends Component {
  static propTypes = {
    skus: PropTypes.arrayOf(PropTypes.object).isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      subscriptionId: null,
    }
  }

  columns = [
    {
      title: 'Sku',
      fieldValue: 'sku',
    },
    {
      title: 'Type',
      fieldValue: sku => {
        const match = this.lookupSku(sku.sku)
        if (match) return match.skuCode
        return 'Invalid sku'
      },
    },
    {
      title: 'Name',
      fieldValue: sku => {
        const match = this.lookupSku(sku.sku)
        if (match) return match.name
        return 'Invalid sku'
      },
    },
    {
      title: 'Quantity',
      fieldValue: 'qty',
    },
  ]

  lookupSku = sku => this.props.refData.skus.get(sku)

  render = () => {
    const { skus } = this.props

    return skus.length ? (
      <Row>
        <AutoTable
          borderless
          columns={this.columns}
          filter
          headThemeLight
          rows={skus}
          sort
        />
      </Row>
    ) : (
      <Alert color="warning">No results found</Alert>
    )
  }
}

const mapStateToProps = ({ refData }) => {
  return {
    refData: refData,
  }
}

export default connect(mapStateToProps)(SkuGrid)



// WEBPACK FOOTER //
// ./src/containers/css-admin/subscriptions/SkuGrid.js